module.exports = __webpack_public_path__ + "images/emoji/clock1.4d3d487eea0f1c1a8d92.png";